export default "<div class=\"grid\">\n\t<div class=\"col-1-4\">\n\t</div>\n\t<div class=\"col-3-4\">\n\t\t<ng-content></ng-content>\n\t</div>\n</div>\n"